import {
	forwardRef,
	type ForwardRefExoticComponent,
	type RefAttributes,
} from 'react';

import Stack, { type StackProps } from '@liquidweb-dev/undercurrent/Stack';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

export const AssetListItemDetail: ForwardRefExoticComponent<
	StackProps & RefAttributes<HTMLDivElement>
> = forwardRef(({ sx, ...rest }, ref) => (
	<Stack
		sx={combineSx(
			{
				flexDirection: 'row',
				gap: 50,
				alignItems: 'center',
				color: ({ vars }) => vars.palette.uc.text.medium,
				typography: 'label-lg',
			},
			sx,
		)}
		ref={ref}
		{...rest}
	/>
));

AssetListItemDetail.displayName = 'AssetListItemDetail';

export default AssetListItemDetail;
